
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ManagePartners from './ManagePartners';

const Psychologists = () => {
  return (
    <>
      <Helmet>
        <title>Manage Psychologists | Admin Portal</title>
      </Helmet>
      <ManagePartners type="Psychologist" />
    </>
  );
};

export default Psychologists;
